// Готові дизайн-теми салону (кольорові гами + шрифт + опційне фонове зображення).
// Користувач обирає пресет одним кліком, далі може донастроїти вручну.
// Кольори: primary (бренд/кнопки), accent, header (шапка), background (тло сторінки),
// surface (картки), text (основний текст). font — з FONT_MAP. bgImageUrl — фон
// сторінки запису (SVG-градієнт як data-URI; порожньо = без фонового зображення).

// Легкий SVG-градієнт як data-URI (self-contained, працює і в проді).
const grad = (c1, c2, angle = 135) =>
  "data:image/svg+xml," +
  encodeURIComponent(
    `<svg xmlns='http://www.w3.org/2000/svg' width='160' height='160'>` +
      `<defs><linearGradient id='g' gradientTransform='rotate(${angle})'>` +
      `<stop offset='0' stop-color='${c1}'/><stop offset='1' stop-color='${c2}'/>` +
      `</linearGradient></defs><rect width='160' height='160' fill='url(#g)'/></svg>`
  );

// Ніжний градієнт із м'яким світловим плямом у кутку (елегантніше за плоский).
const glow = (base, spot, sx = 22, sy = 18) =>
  "data:image/svg+xml," +
  encodeURIComponent(
    `<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'>` +
      `<rect width='200' height='200' fill='${base}'/>` +
      `<circle cx='${sx}%' cy='${sy}%' r='70%' fill='${spot}' opacity='0.45'/></svg>`
  );

export const THEME_PRESETS = [
  {
    id: "emerald",
    name: { pl: "Szmaragd i złoto", uk: "Смарагд і золото", en: "Emerald & gold" },
    colors: { primary: "#0F5C4E", accent: "#C9A24B", header: "#0B3D34", background: "#F5F1E8", surface: "#FFFFFF", text: "#20241F" },
    font: "Playfair Display",
    bgImageUrl: glow("#0B3D34", "#12564A"),
  },
  {
    id: "blush",
    name: { pl: "Różowy kwarc", uk: "Рожевий кварц", en: "Rose quartz" },
    colors: { primary: "#C25B7C", accent: "#E0A6BA", header: "#A23E5F", background: "#FBF3F6", surface: "#FFFFFF", text: "#3A2830" },
    font: "Poppins",
    bgImageUrl: "",
  },
  {
    id: "noir",
    name: { pl: "Noir", uk: "Нуар", en: "Noir" },
    colors: { primary: "#C9A24B", accent: "#E5C877", header: "#0D0D0D", background: "#15120D", surface: "#211C14", text: "#F0E9DC" },
    font: "Playfair Display",
    bgImageUrl: glow("#100E0A", "#2A2417"),
  },
  {
    id: "ocean",
    name: { pl: "Ocean", uk: "Океан", en: "Ocean" },
    colors: { primary: "#0E7C86", accent: "#3BB6C2", header: "#0A565E", background: "#EEF6F7", surface: "#FFFFFF", text: "#16292B" },
    font: "Inter",
    bgImageUrl: grad("#0A565E", "#0E7C86", 120),
  },
  {
    id: "lavender",
    name: { pl: "Lawenda", uk: "Лаванда", en: "Lavender" },
    colors: { primary: "#6C5CA6", accent: "#A88FD8", header: "#4A3B78", background: "#F5F2FA", surface: "#FFFFFF", text: "#2A2440" },
    font: "Lora",
    bgImageUrl: "",
  },
  {
    id: "terracotta",
    name: { pl: "Ciepły beż", uk: "Теплий беж", en: "Warm terracotta" },
    colors: { primary: "#B5744E", accent: "#DBA77E", header: "#8A5334", background: "#F8F1E8", surface: "#FFFFFF", text: "#33261C" },
    font: "Playfair Display",
    bgImageUrl: glow("#C98A5E", "#E7C9A8", 78, 24),
  },
  {
    id: "minimal",
    name: { pl: "Minimal", uk: "Мінімал", en: "Minimal" },
    colors: { primary: "#1A1A1A", accent: "#7A7A7A", header: "#111111", background: "#FAFAFA", surface: "#FFFFFF", text: "#1A1A1A" },
    font: "Inter",
    bgImageUrl: "",
  },
  {
    id: "barber",
    name: { pl: "Barbershop", uk: "Барбершоп", en: "Barbershop" },
    colors: { primary: "#A6742C", accent: "#D19A46", header: "#161310", background: "#1B1712", surface: "#241E18", text: "#ECE2D2" },
    font: "Montserrat",
    bgImageUrl: glow("#171310", "#3A2C1C"),
  },
  {
    id: "sunset",
    name: { pl: "Zachód słońca", uk: "Захід сонця", en: "Sunset" },
    colors: { primary: "#E5624D", accent: "#F2A65A", header: "#C13B2E", background: "#FFF5EC", surface: "#FFFFFF", text: "#3A241C" },
    font: "Poppins",
    bgImageUrl: grad("#F2A65A", "#E5624D", 115),
  },
  {
    id: "royal",
    name: { pl: "Granat i złoto", uk: "Королівський синій", en: "Royal navy" },
    colors: { primary: "#1E2A5A", accent: "#C9A24B", header: "#141E42", background: "#F4F5FA", surface: "#FFFFFF", text: "#1A2035" },
    font: "Playfair Display",
    bgImageUrl: glow("#141E42", "#26326A"),
  },
  {
    id: "mint",
    name: { pl: "Świeża mięta", uk: "Свіжа мʼята", en: "Fresh mint" },
    colors: { primary: "#2FA36B", accent: "#8FD9B6", header: "#1E7A4E", background: "#F0FAF4", surface: "#FFFFFF", text: "#17342A" },
    font: "Inter",
    bgImageUrl: "",
  },
  {
    id: "wine",
    name: { pl: "Wino i krem", uk: "Вино і крем", en: "Wine & cream" },
    colors: { primary: "#7A2233", accent: "#B85C6E", header: "#591826", background: "#FBF3F1", surface: "#FFFFFF", text: "#2E1A1E" },
    font: "Lora",
    bgImageUrl: glow("#591826", "#7A2233"),
  },
  {
    id: "graphite",
    name: { pl: "Grafit", uk: "Графіт", en: "Graphite" },
    colors: { primary: "#F5F5F5", accent: "#9AA0A6", header: "#0A0A0A", background: "#141414", surface: "#1E1E1E", text: "#EDEDED" },
    font: "Montserrat",
    bgImageUrl: glow("#0E0E0E", "#242424"),
  },
  {
    id: "peach",
    name: { pl: "Brzoskwinia", uk: "Персик і нюд", en: "Peach & nude" },
    colors: { primary: "#D98B7A", accent: "#EFC3B3", header: "#B96A57", background: "#FDF5F1", surface: "#FFFFFF", text: "#3A2A24" },
    font: "Poppins",
    bgImageUrl: "",
  },
  {
    id: "forest",
    name: { pl: "Las", uk: "Лісова зелень", en: "Forest" },
    colors: { primary: "#2E5D3B", accent: "#A3B18A", header: "#1D3D26", background: "#F3F5EF", surface: "#FFFFFF", text: "#1E2A1E" },
    font: "Lora",
    bgImageUrl: grad("#1D3D26", "#2E5D3B", 130),
  },
  {
    id: "cobalt",
    name: { pl: "Kobalt", uk: "Кобальт", en: "Cobalt" },
    colors: { primary: "#2456C7", accent: "#5B8DEF", header: "#16367F", background: "#F2F5FC", surface: "#FFFFFF", text: "#16203A" },
    font: "Inter",
    bgImageUrl: grad("#16367F", "#2456C7", 120),
  },
];

// Локалізована назва пресету за поточною мовою UI.
export const presetName = (preset, lang) =>
  (preset.name && (preset.name[lang] || preset.name.uk || preset.name.en)) || preset.id;
